class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

function isWithinMegaMenuZone(target) {
  if (!target || !(target instanceof Element)) return false;

  return Boolean(
    target.closest('.mega-menu__content') ||
    target.closest('.mega-menu__item') ||
    target.closest('details.mega-menu')
  );
}

function closeAllMegaMenus(root = document) {
  root.querySelectorAll('header-menu').forEach((menu) => {
    if (menu.mainDetailsToggle?.classList.contains('mega-menu')) {
      menu.close();
    }
  });
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
    this.hoverCloseTimeout = null;

    if (this.isMegaMenu) {
      this.initMegaMenuHover();
    }
  }

  initMegaMenuHover() {
    this.listItem = this.closest('li');
    this.inlineMenu = this.closest('.header__inline-menu');

    this.summary.addEventListener('mousedown', (event) => {
      if (event.button === 0) event.preventDefault();
    });

    this.listItem?.addEventListener('mouseenter', () => this.openMegaMenu());

    this.content.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverCloseTimeout);
    });

    this.content.addEventListener('mouseleave', (event) => {
      if (isWithinMegaMenuZone(event.relatedTarget)) return;
      this.scheduleMegaMenuClose();
    });

    if (this.inlineMenu && !this.inlineMenu.dataset.megaMenuHoverInit) {
      this.inlineMenu.dataset.megaMenuHoverInit = 'true';

      this.inlineMenu.addEventListener('mouseover', (event) => {
        if (event.target.closest('.mega-menu__content')) return;

        const listItem = event.target.closest('.list-menu--inline > li');
        if (!listItem || listItem.querySelector('details.mega-menu')) return;
        closeAllMegaMenus(this.inlineMenu);
      });
    }

    if (this.header && !this.header.dataset.megaMenuHoverInit) {
      this.header.dataset.megaMenuHoverInit = 'true';

      this.header.addEventListener('mouseleave', (event) => {
        if (isWithinMegaMenuZone(event.relatedTarget)) return;
        closeAllMegaMenus(this.header);
      });
    }
  }

  openMegaMenu() {
    clearTimeout(this.hoverCloseTimeout);

    this.inlineMenu?.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle?.classList.contains('mega-menu')) {
        menu.close();
      }
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }

    this.onToggle();
  }

  scheduleMegaMenuClose() {
    clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = setTimeout(() => this.close(), 220);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open');

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
